import React, {Component} from "react"

import authentication from "@irati/auth"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import medicalTracking from "@irati-tracking/medical"

import {IFrameWrapper, IFrame} from "./styled"

interface Props extends InjectIntl {}

interface State {
  hasVideoTrackingEventFired: boolean
}

class Video extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      hasVideoTrackingEventFired: false
    }
    this.video = React.createRef()
  }

  componentDidMount() {
    window.addEventListener("message", this.onMessageReceived, false)
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.onMessageReceived, false)
  }

  getHighestTier = () => {
    if (authentication.apps("medical.tiers.tier3")) {
      return 3
    } else if (authentication.apps("medical.tiers.tier2")) {
      return 2
    }
    return 1
  }

  onMessageReceived = (e) => {
    if (e.origin === "https://player.vimeo.com") {
      const data = JSON.parse(e.data)
      if (data.event === "ready") {
        const postData = {method: "addEventListener", value: "play"}
        this.video.current.contentWindow.postMessage(JSON.stringify(postData), this.video.current.src)
      } else if (data.event === "play") {
        const {hasVideoTrackingEventFired} = this.state
        if (!hasVideoTrackingEventFired) {
          this.setState({hasVideoTrackingEventFired: true})
          medicalTracking.viewVideo(this.getHighestTier())
        }
      }
    }
  }

  render() {
    const {formatMessage} = this.props
    const hasTier2Access = authentication.apps("medical.tiers.tier2")
    return (
      <IFrameWrapper>
        <IFrame
          ref={this.video}
          frameBorder="0"
          allowFullScreen
          mozallowfullscreen
          webkitAllowFullScreen
          title="MedicalVideo"
          src={formatMessage({id: hasTier2Access ? "medical.landing.video.tier2" : "medical.landing.video.tier1"})} />
      </IFrameWrapper>
    )
  }
}

export default injectIntl(Video)
